export const Feedback = ({ handleFeedback }) => {
  const feedbackLabels = ["Excellent", "Good", "Poor"];
  const feedbackColors = ["#66ff9cff", "#e5ff66ff", "#ff6666"];
  const feedbackEmojis = ["😀", "😐", "😡"];
 
  return (
    <div className="feedback-container p-2 my-2 border rounded">
      <p className="feedback-message fw-bold">
        Before we wrap up, how was your experience today?      
      </p>
      <div className="buttons-container d-flex flex-wrap gap-2">
        {feedbackEmojis.map((emoji, i) => (
          <button
            key={i}
            className="feedback-button btn text-white"
            style={{ backgroundColor: feedbackColors[i] }}
            onClick={() => handleFeedback(i + 1)}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};